import { REQUEST_LOCALE, RECEIVE_LOCALE } from '../constants';

import mcUserInfo from '../../utilities/mcUserInfo';

export function getLocale(options = {}) {
  return dispatch => {
    dispatch({ type: REQUEST_LOCALE });

    return mcUserInfo(options.mcLib).then(locale =>
      dispatch({ type: RECEIVE_LOCALE, locale })
    );
  };
}
